import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_app/sales/offers/$offerId/editor/")({
  beforeLoad: ({params}) => {
    throw redirect({
      to: "/sales/offers/editor/$customerOfferId",
      params: {customerOfferId: params.offerId},
      replace: true,
    });
  },
});
